import { objectToUrlParams } from 'utils/params';
import BaseResource from './BaseResource';

export default class MarketplaceCategoryResource extends BaseResource {
  constructor(url) {
    super({ url });
  }

  get() {
    return super
      .get()
      .then((response) => response)
      .catch((error) => error.response);
  }

  update(data) {
    return super
      .patch(data)
      .then((response) => response)
      .catch((error) => error.response);
  }

  delete() {
    return super
      .delete()
      .then((response) => response)
      .catch((error) => error.response);
  }

  products(params = { includes: 'variants,supplier' }) {
    const urlParams = objectToUrlParams(params);
    return super
      .get({ url: `${this.url}/products${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }
}
